module.exports = __webpack_public_path__ + "img/btn_first_esports.dd078504.png";